webpackJsonp([64],{

/***/ "/Gvf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        // 报名弹窗
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        _visible: {
            get: function get() {
                return this.visible;
            },
            set: function set(val) {
                this.$emit('change', val);
            }
        }
    },
    data: function data() {
        return {
            enrollform: {
                name: '',
                phoneNumber: '',
                subject: '',
                grade: ''
            },
            gradeArray: [{ gradeName: '初一', code: 10 }, { gradeName: '初二', code: 20 }, { gradeName: '初三', code: 30 }, { gradeName: '高一', code: 50 }, { gradeName: '高二（文科）', code: 61 }, { gradeName: '高二（理科）', code: 62 }, { gradeName: '高三（文科）', code: 71 }, { gradeName: '高三（理科）', code: 72 }],
            subjectArray: [{ subjectName: '语文', code: '21' }, { subjectName: '数学', code: '20' }, { subjectName: '英语', code: '3' }, { subjectName: '物理', code: '6' }, { subjectName: '化学', code: '5' }, { subjectName: '生物', code: '27' }],
            hint: {
                show: false,
                text: ''
            },
            loading: false,
            showSuccess: false,
            showIcon: true,
            showToast: false
        };
    },

    watch: {
        visible: function visible(val) {
            if (!val) {
                this.flag = true;
            }
        }
    },
    methods: {
        // ...mapActions(['USER_POST_SIGNUP']),
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleSignUp: function handleSignUp(formName) {
            var _this = this;

            if (this.loading) return;
            if (!this.showIcon) {
                this.showToast = true;
                setTimeout(function () {
                    _this.showToast = false;
                }, 3000);
                return;
            }
            var _enrollform = this.enrollform,
                name = _enrollform.name,
                phoneNumber = _enrollform.phoneNumber,
                grade = _enrollform.grade,
                subject = _enrollform.subject;

            if (!name) {
                return this.showHint('请输入学生姓名');
            }
            if (!phoneNumber) {
                return this.showHint('请输入手机号码');
            } else if (!/^1[0-9]{10}$/.test(phoneNumber)) {
                return this.showHint('请输入正确的11位手机号码');
            }
            if (!grade) {
                return this.showHint('请选择年级');
            }
            if (!subject) {
                return this.showHint('请选择学科');
            }
            this.loading = true;
            this.$http.post('/v1/appointments', {
                flag: 'hfsfd-ow',
                name: name,
                phone: phoneNumber,
                grade: grade,
                subject: subject,
                pageFlag: '官网报名'
            }).then(function (resp) {
                if (resp.code === 0) {
                    return {
                        success: true
                    };
                } else if (resp.code === 1004 || resp.code === 3101) {
                    return {
                        hasSignUp: true
                    };
                } else {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject({
                        code: resp.code,
                        msg: resp.msg
                    });
                }
            }).then(function (data) {
                if (data.success) {
                    _this.enrollform = {
                        name: '',
                        phoneNumber: '',
                        subject: '',
                        grade: ''
                    };
                    _this.showSuccess = true;
                } else {
                    _this.showHint('已经报过名');
                }
            }).catch(function (err) {
                _this.$message.error(err.msg);
            }).finally(function () {
                _this.loading = false;
            });
        },
        showHint: function showHint(text) {
            var _this2 = this;

            this.hint.text = text;
            this.hint.show = true;
            setTimeout(function () {
                _this2.hint.show = false;
            }, 3000);
        },

        // 跳转儿童协议
        childPrivaryPolicy: function childPrivaryPolicy() {
            window.location.href = feConfig.agreementUrl + '/childPrivaryPolicy.html';
        },

        // 跳转用户协议
        userAgreement: function userAgreement() {
            window.location.href = feConfig.agreementUrl + '/userAgreement.html';
        },

        // 跳转隐私协议
        privacyAgreement: function privacyAgreement() {
            window.location.href = feConfig.agreementUrl + '/privaryPolicy.html';
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("kdwg")))

/***/ }),

/***/ "1tYL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gaba.d0289dc.png";

/***/ }),

/***/ "28he":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    install: function install(Vue) {
        Vue.handleError = function (err, msg) {
            if (typeof arguments[0] === 'string') {
                err = { msg: arguments[0] };
            }
            Vue.prototype.$message.error(err.msg || err.message || msg || '请求失败');
        };
        Object.defineProperty(Vue.prototype, '$handleError', { value: Vue.handleError });
    }
};

/***/ }),

/***/ "50dM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_11_4.ba57e54.png";

/***/ }),

/***/ "7IAX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8q/s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _enum = __webpack_require__("vvAD");

var _enum2 = _interopRequireDefault(_enum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = _axios2.default.create({
    baseURL: '' + feConfig.api.base,
    timeout: '' + feConfig.api.timeout,
    withCredentials: true
});

instance.interceptors.request.use(function (config) {
    if (config.params && config.params.cookieStr) {
        console.log(config, 'config.........');
        document.cookie = config.params.cookieStr;
        delete config.params.cookieStr;
    }
    return config;
});

instance.interceptors.response.use(function (response) {
    if (response && _enum2.default.ErrorCode.CookieInvalid === response.data.code) {
        // 如果是移动端，cookie失效后触发InvalidCookie事件
        if (window.androidTest) {
            window.androidTest.InvalidCookie();
        }
        if (window.webkit) {
            window.webkit.messageHandlers.InvalidCookie.postMessage(null);
        }
        // 清空cookie值
        var d = new Date();
        d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
        document.cookie = feConfig.cookie.key + '= ;domain=' + feConfig.cookie.domain + ';expires=' + d.toUTCString();
        location.href = '/';
    }
    return response.data;
}, function (err) {
    if (err.response) {
        return _promise2.default.reject(err.response.data);
    }
    return _promise2.default.reject({ code: 1024, message: err.message });
});

function axios(options) {
    var cookie = null;
    if (options.cookie) {
        cookie = options.cookie.key + '=' + options.cookie.value;
        delete options.cookie;
    }
    var instance = _axios2.default.create((0, _assign2.default)({
        timeout: '' + feConfig.api.timeout
    }, options, cookie ? { headers: { Cookie: cookie } } : {}));
    instance.interceptors.response.use(function (response) {
        return response.data;
    }, function (err) {
        if (err.response) {
            return _promise2.default.reject(err.response.data);
        }
        return _promise2.default.reject({ code: 1024, message: err.message });
    });
    return instance;
}

function plugin(Vue) {
    if (plugin.installed) {
        return;
    }
    Vue.http = instance;
    Vue.axios = axios;
    Object.defineProperty(Vue.prototype, '$http', { value: instance });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

exports.default = plugin;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("kdwg")))

/***/ }),

/***/ "9aQH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_11_2.7f8eed6.png";

/***/ }),

/***/ "A+HM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHkG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAolBMVEUAAAD/TAD/TAD/TQD/UAD/VQD/TAD/TAD/TAD/TAD/TQD/TQD/TQD/TQD/TwD//wD/TAD/TAD/TQD/TQD/TQD/TQD/TQD/TgD/TQD/UQD/UgD/WgD/XQD/TAD/////YyL/jFz/VQ7/28z/vaH/dDr/TwX/9vP/6N//waf/o3z/eD//9/X/9fH/6uL/4dX/08H/xKz/q4j/kmX/f0n/aCj/XRkJ2R6NAAAAHXRSTlMA0rydLRf89PDcv7BaRzgB5eDXzbeFe2UyJh8RC6UBJPMAAAD+SURBVCjPdZBXdoMwEEVHDUw17k5sDc09ve1/a1FAlkCQ+6OH7nlozsCdaboKA38yp2sODtM4kAaS9NzDQvagwrpkIh2yrXGeHOBz/U/VGzITzSwLOUoEilj+Q6qKgXt5+MqbMwRIXXdFvLVJwMrtIX7ouIGw78ozVkedGegn87y9uuApN3sCvw0VvpbqKBALu2PQG/h+wlr1T3iRHTnX6VN1jhWeSyuXQO/xHZ9rxIO0MFibOV8Q8So7xMBNviG+dZ23AyDmq6h/3M0nchyPg4KOSwZ/iGzMkT00bP2hyx5Bw2eDXuNaRNSfhe2hSxpaFXFwERtGCVmyeGeufgGTi0SkPp9ExgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "PKNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper__ = __webpack_require__("99MR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SignupDialog__ = __webpack_require__("xQFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("y7q8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import LazyImage from '../../assets/plugin/lazyImage';

var TeacherCardsData = [{
    index: 1, // 对应图片文件名
    name: '赵艳君',
    tags: ['英语学科带头人', '10年教龄'],
    subject: '英语',
    count: '数千名学员',
    time: '数千小时',
    features: ['精准把握英语学科命题与学习规律', '出版经典学科类教辅书十余本', '注重互动式教学和引发学习兴趣']
}, {
    index: 2, // 对应图片文件名
    name: '王瑞',
    tags: ['语文高级教师', '13年教龄'],
    subject: '语文',
    count: '学员数千名',
    time: '数千小时',
    features: ['多年从事语文教研及一线教学工作', '熟悉各地中考考纲考情，擅长个别化精准指导', '激发学生学习兴趣，提高学生学习能力']
}, {
    index: 3, // 对应图片文件名
    name: '黄栋',
    tags: ['英语高级教师', '5年教龄'],
    subject: '英语',
    count: '数千名学员',
    time: '数千小时',
    features: ['深入研究英语命题和学习提升规律', '对薄弱生提升有独特方法', '注重启发式教学和情境教学']
}, {
    index: 4, // 对应图片文件名
    name: '杨元通',
    tags: ['数学高级教师', '5年教龄'],
    subject: '数学',
    count: '学员数百名',
    time: '数千小时',
    features: ['研究多年数学命题和学科学习规律', '擅长重难点题型拆分讲解', '注重化繁为简传授方法']
}, {
    index: 5, // 对应图片文件名
    name: '郭锦莎',
    tags: ['数学高级教师', '5年教龄'],
    subject: '数学',
    count: '学员数百名',
    time: '数千小时',
    features: ['精准把握高考考情及考试规律', '擅长重难点题型的方法总结及引导', '是关注学生学习心理的良师益友']
}];
var LessonCardsData = [{
    index: 1,
    name: '精准同步课',
    secondTitle: '紧密贴合学校进度   学习难度实时调控',
    des: '利用好分数独有的考试大数据精确定位学生当前学业等级，推荐同步学习胶囊，对学校正学的知识点进行全方位讲解。课后基因导学引擎为学生推荐个性化练习和测评，实时指导学习内容的调整。',
    beforeClass: '预习卡片、视频',
    inClass: '作业讲评、课程目标、知识讲解/例题/练习、课程总结',
    afterClass: '复习资料'
}, {
    index: 2,
    name: '考前复习课',
    secondTitle: '重点知识串讲梳理，定制最有效的备考方案',
    des: '根据考前所学内容进行串讲，构建知识网络。针对学生班级、年级的共性错题和历届学生的共性错题进行讲解训练，考前查漏补缺。提供备考策略，帮助学生做好复习。',
    beforeClass: '预习卡片、视频',
    inClass: '课程目标、知识串讲、错题-例题/练习、课程总结、备考策略',
    afterClass: '考前知识复习、考前综合练'
}, {
    index: 3,
    name: '考前冲关课',
    secondTitle: '易错点精准辅导，帮你成功闯关升级',
    des: '通过独家校本小53考情数据分析历年高频常考点、易错点进行重点讲解，结合学生个人错题数据，在考前攻克关键提升点。',
    beforeClass: '预习卡片、视频',
    inClass: '小53考情分析、复习计划、课程目标、错题精练、课程总结、备考策略',
    afterClass: '考前指南、考前冲刺卷、考前冲关练'
}, {
    index: 4,
    name: '考后分析课',
    secondTitle: '大数据考后诊断，全面补漏高效提升',
    des: '多维考试分析，全面识别学生知识和能力漏洞 。讲解典型错题并深挖错因，对错题背后的知识进行拓展讲解。针对试卷分析和错因分析，结合学生层级制定专属提升规划，及时调整，巩固提升。',
    beforeClass: '知识串讲',
    inClass: '本次试卷分析、课程目标、错题精讲、课程总结、考后规划',
    afterClass: '考后错题练、考后追踪卷'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SignupDialog: __WEBPACK_IMPORTED_MODULE_1__components_SignupDialog__["a" /* default */]
    },
    data: function data() {
        return {
            headerFixed: false,
            TeacherCardsData: TeacherCardsData,
            LessonCardsData: LessonCardsData,
            lessonSwiper: null,
            reasonSwiper: null,
            teacherSwiper: null,
            signupDialogVisible: false,
            teacherCardsData: []
        };
    },
    beforeMount: function beforeMount() {
        this.windowBindScroll();
    },
    mounted: function mounted() {
        document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
        window.addEventListener('resize', this.resizeHandler);
        // this.swiperInit();
        // this.lazyImageInit();
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        this.windowRemoveScroll();
    },
    created: function created() {
        this.getTeacherCardsData();
    },

    methods: {
        resizeHandler: function resizeHandler() {
            var firstOnResizeFire = true;
            if (firstOnResizeFire) {
                document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
                firstOnResizeFire = false;
                setTimeout(function () {
                    firstOnResizeFire = true;
                }, 500);
            }
        },
        swiperInit: function swiperInit() {
            this.teacherSwiper = new __WEBPACK_IMPORTED_MODULE_0_swiper___default.a('.teachers-carousel__main', {
                autoplay: true,
                loop: true,
                slidesPerView: 1.1,
                spaceBetween: 15,
                centeredSlides: true,
                pagination: {
                    el: '.teachers-swiper-pagination',
                    type: 'bullets'
                }
            });
            this.reasonSwiper = new __WEBPACK_IMPORTED_MODULE_0_swiper___default.a('.reason-cards__main', {
                autoplay: true,
                loop: true,
                slidesPerView: 5,
                loopedSlides: 7,
                centeredSlides: true,
                pagination: {
                    el: '.reason-swiper-pagination',
                    type: 'bullets'
                }
            });
            this.lessonSwiper = new __WEBPACK_IMPORTED_MODULE_0_swiper___default.a('.lesson-carousel__main', {
                // 前进后退按钮
                autoplay: true,
                loop: true,
                centeredSlides: true,
                // autoHeight: true,
                slidesPerView: 4,
                loopedSlides: 5,
                pagination: {
                    el: '.lesson-swiper-pagination',
                    type: 'bullets'
                }
            });
            this.honorSwiper = new __WEBPACK_IMPORTED_MODULE_0_swiper___default.a('.company-honor__main', {
                autoplay: true,
                loop: true,
                slidesPerView: 3,
                loopedSlides: 5,
                centeredSlides: true,
                pagination: {
                    el: '.reason-swiper-pagination',
                    type: 'bullets'
                }
            });
        },
        windowBindScroll: function windowBindScroll() {
            window.addEventListener('scroll', this.handleScroll);
        },
        windowRemoveScroll: function windowRemoveScroll() {
            window.removeEventListener('scroll', this.handleScroll);
        },

        handleScroll: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.throttle(function (e) {
            var scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
            this.headerFixed = scrollTop !== 0;
        }, 200),
        // 获取名师信息
        getTeacherCardsData: function getTeacherCardsData() {
            var _this = this;

            this.$http.get('/v1/teachers/show-on-website/list?isFamous=1').then(function (resp) {
                return _this.$checkResp(resp);
            }).then(function (data) {
                _this.teacherCardsData = data;
                _this.$nextTick(function () {
                    _this.swiperInit();
                });
            }).catch(function (err) {
                _this.$handleError(err);
            });
        },

        // 跳转儿童协议
        childPrivaryPolicy: function childPrivaryPolicy() {
            window.location.href = feConfig.agreementUrl + '/childPrivaryPolicy.html';
        },

        // 跳转用户协议
        userAgreement: function userAgreement() {
            window.location.href = feConfig.agreementUrl + '/userAgreement.html';
        },

        // 跳转隐私协议
        privacyAgreement: function privacyAgreement() {
            window.location.href = feConfig.agreementUrl + '/privaryPolicy.html';
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("kdwg")))

/***/ }),

/***/ "PO+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("PKNZ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4602de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("vj9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("7IAX")
  __webpack_require__("A+HM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a4602de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4602de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4602de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PoFL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_11_1.4bd3b50.png";

/***/ }),

/***/ "RJlG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAMFBMVEUAAACampqYmJiXl5eZmZmXl5eXl5eYmJiYmJicnJyampqbm5unp6f///+ZmZmXl5cJG8Y6AAAAEHRSTlMAQdnKherzvlQxJiEMAWtsfamgeAAAAIlJREFUGNNjAAFOd7WkkgkMUMCh5LjmlIhSA4THbSwAohiNN4C5om8hwvcCwaIgEiIOUrVVAMZljAYSdgxw8BhorC2Ce7mBgUkAwWVUYJjEgAQ0GVyQeEBOITJXnEELmbuIIQeZewyNi6YYzSg0i9CcgeZINC+gePAzmvfRAgc16NACFiPY0SIFAGVzIFdjdnLTAAAAAElFTkSuQmCC"

/***/ }),

/***/ "V9j6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 统一处理API返回的数据
 * @param {*} resp: axios返回的对象
 * @param {*} emptyDefault（可选）: 指定当code === 1 时应该返回什么。
 */
var checkResp = function checkResp(resp, emptyDefault) {
    if (resp && (resp.code === 0 || resp.code === 1)) {
        if (resp.code === 1 && emptyDefault) {
            return emptyDefault;
        }
        return resp.data;
    }
    return _promise2.default.reject(resp);
};

exports.default = {
    install: function install(Vue) {
        Vue.checkResp = checkResp;
        Object.defineProperty(Vue.prototype, '$checkResp', { value: Vue.checkResp });
    }
};

/***/ }),

/***/ "Y8qX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_11_5.8f1bcf7.png";

/***/ }),

/***/ "g5hg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._visible),expression:"_visible"}],staticClass:"signup-dialog"},[_c('div',{staticClass:"signup-dialog__mask"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showSuccess),expression:"!showSuccess"}],staticClass:"signup-dialog__main"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.enrollform.name),expression:"enrollform.name",modifiers:{"trim":true}}],staticClass:"signup-dialog__input",attrs:{"auto-complete":"off","placeholder":"请输入学生姓名"},domProps:{"value":(_vm.enrollform.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.enrollform, "name", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.enrollform.phoneNumber),expression:"enrollform.phoneNumber",modifiers:{"trim":true}}],staticClass:"signup-dialog__input",attrs:{"auto-complete":"off","placeholder":"请输入您的手机号"},domProps:{"value":(_vm.enrollform.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.enrollform, "phoneNumber", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"signup-dialog__row-3"},[_c('div',{staticClass:"signup-dialog__select-wrap"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.enrollform.grade),expression:"enrollform.grade"}],staticClass:"signup-dialog__select",class:{'signup-dialog__select--disabled':!_vm.enrollform.grade},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.enrollform, "grade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{staticStyle:{"display":"none"},attrs:{"value":"","disabled":"","selected":""}},[_vm._v("请选择年级")]),_vm._v(" "),_vm._l((_vm.gradeArray),function(item){return _c('option',{key:item.code,attrs:{"label":item.gradeName},domProps:{"value":item.code}},[_vm._v(_vm._s(item.gradeName))])})],2)]),_vm._v(" "),_c('div',{staticClass:"signup-dialog__select-wrap"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.enrollform.subject),expression:"enrollform.subject"}],staticClass:"signup-dialog__select",class:{'signup-dialog__select--disabled':!_vm.enrollform.subject},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.enrollform, "subject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{staticStyle:{"display":"none"},attrs:{"value":"","disabled":"","selected":""}},[_vm._v("请选择学科")]),_vm._v(" "),_vm._l((_vm.subjectArray),function(item){return _c('option',{key:item.code,attrs:{"label":item.subjectName},domProps:{"value":item.code}},[_vm._v(_vm._s(item.subjectName))])})],2)])]),_vm._v(" "),_c('span',{staticClass:"signup-dialog__submit",on:{"click":function($event){_vm.handleSignUp('enrollform')}}},[_vm._v(_vm._s(_vm.loading?'提交中...':'名额有限，立即领取'))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hint.show),expression:"hint.show"}],staticClass:"signup-dialog__hint"},[_vm._v("* "+_vm._s(_vm.hint.text))]),_vm._v(" "),_c('div',{staticClass:"agreement"},[(_vm.showIcon)?_c('img',{staticClass:"agreement-pic",attrs:{"src":__webpack_require__("NHkG"),"alt":""},on:{"click":function($event){_vm.showIcon = false}}}):_c('img',{staticClass:"agreement-pic",attrs:{"src":__webpack_require__("RJlG"),"alt":""},on:{"click":function($event){_vm.showIcon = true}}}),_vm._v(" "),_c('span',{staticClass:"agreement-text"},[_vm._v("同意"),_c('span',{staticStyle:{"color":"#3d6eb8"},on:{"click":_vm.userAgreement}},[_vm._v("《好分数辅导用户协议》、")]),_c('span',{staticStyle:{"color":"#3d6eb8"},on:{"click":_vm.privacyAgreement}},[_vm._v("《好分数辅导隐私政策》")]),_vm._v("和"),_c('span',{staticStyle:{"color":"#3d6eb8"},on:{"click":_vm.childPrivaryPolicy}},[_vm._v("《儿童隐私政策》")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuccess),expression:"showSuccess"}],staticClass:"success-view"},[_c('i',{staticClass:"success-view__icon"}),_vm._v(" "),_c('span',{staticClass:"success-view__title"},[_vm._v("提交成功")]),_vm._v(" "),_c('span',{staticClass:"success-view__text"},[_vm._v("您已预约成功，24小时内会有课程顾问跟您联系")]),_vm._v(" "),_c('span',{staticClass:"success-view__btn",on:{"click":function($event){_vm._visible=false;_vm.showSuccess=false}}},[_vm._v("确定")])]),_vm._v(" "),_c('i',{staticClass:"signup-dialog__close-btn",on:{"click":function($event){_vm._visible=false;_vm.showSuccess=false}}}),_vm._v(" "),(_vm.showToast)?_c('div',{staticClass:"show-toast"},[_c('div',{staticClass:"show-toast-text"},[_vm._v("请勾选同意《好分数辅导用户协议》、《好分数辅导隐私政策》和《儿童隐私政策》")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"signup-dialog__title"},[_vm._v("免费预约"),_c('span',{staticClass:"high-light"},[_vm._v("价值1对1在线")]),_vm._v("试听")])}]


/***/ }),

/***/ "kdwg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    isProduction: true,
    api: {
        base: 'https://hfsfd-be.haofenshu.com',
        captcha: 'https://hfs2-avatar.yunxiao.com',
        slideCaptcha: 'https://hfsfd3-captcha.haofenshu.com',
        timeout: 200000
    },
    hfsStoreApi: 'https://fd-store-serv-wan.haofenshu.com',
    ssoApi: {
        base: 'http://sso.yunxiao.com',
        timeout: 200000
    },
    teacherApi: {
        base: 'http://fudaojs.haofenshu.com'
    },
    appTeacherApi: {
        base: 'https://hfsfd-teacher.haofenshu.com'
    },
    imgService: {
        prefix: 'hfsfd'
    },
    cookie: {
        key: 'hfsfd-session-id',
        domain: '.haofenshu.com'
    },
    domain: 'https://fudao.haofenshu.com',
    CmbcUrl: 'https://pay.creditcard.cmbc.com.cn/pay/cmbcApply/perpaidOrder',
    jiankeapp: {
        jianketiaozhuan: 'fudaotool://tool.fudao.aiyunxiao.com/start?pageType=2&timetableId=',
        iosDownload: 'https://itunes.apple.com/cn/app/id1508095015',
        androidDownload: 'https://appvm.yunxiao.com/dl/5e816951969df601c7b632c4'
    },
    trackPoint: {
        feMonitor: '//fe-monitor.iyunxiao.com', // trackPonit 配置获取地址
        projectId: '5da18b6b00000561022c2539', // 项目 ID
        baseURL: '//fe-monitor.iyunxiao.com', // 上报地址
        time: 5000, // 上报间隔
        sKey: 'FD_HFS_STUDENT_TrackPoint', // 本地 storge 缓存 key，可根据项目修改
        eventType: ['click'] // 事件类型
    },
    agreementUrl: 'https://fudaomkt.haofenshu.com'
};

/***/ }),

/***/ "lz0s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mE6Z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_11_3.966c570.png";

/***/ }),

/***/ "vUwe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("j1ja");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("PO+z");

var _App2 = _interopRequireDefault(_App);

var _axios = __webpack_require__("8q/s");

var _axios2 = _interopRequireDefault(_axios);

var _checkResp = __webpack_require__("V9j6");

var _checkResp2 = _interopRequireDefault(_checkResp);

var _handleError = __webpack_require__("28he");

var _handleError2 = _interopRequireDefault(_handleError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// sync the router with the vuex store.

_vue2.default.use(_axios2.default);
_vue2.default.use(_checkResp2.default);
_vue2.default.use(_handleError2.default);

_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
    el: '#app',
    components: { App: _App2.default },
    template: '<App/>'
});

/***/ }),

/***/ "vj9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page",on:{"scroll":_vm.handleScroll}},[_c('div',{staticClass:"home-header",class:{'home-header--fixed': true}},[_c('div',{staticClass:"home-header__container"},[_c('h1',{staticClass:"home-header__logo"}),_vm._v(" "),_c('div',{staticClass:"header-nav"},[_c('div',{class:['header-nav__item','header-nav__item--active'],nativeOn:{"mouseenter":function($event){_vm.activeNav='home'},"mouseleave":function($event){_vm.activeNav=_vm.curNav}}},[_vm._v("\n                    首页\n                ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://4020224467078.retail.n.weimob.com/saas/retail/4020224467078/6013963227078/shop/index","target":"_blank"}},[_c('div',{class:['header-nav__item',_vm.activeNav==='shop'?'header-nav__item--active':''],nativeOn:{"mouseenter":function($event){_vm.activeNav='shop'},"mouseleave":function($event){_vm.activeNav=_vm.curNav}}},[_vm._v("\n                        好分数商城\n                    ")])])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"home-page__section home-page__section--3"},[_c('h3',{staticClass:"home-page__subtitle home-page__subtitle--03"},[_vm._v("优秀老师，行业优选")]),_vm._v(" "),_c('div',{staticClass:"teachers-carousel-img"}),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","height":"4.63rem","overflow":"hidden"}},[_c('div',{staticClass:"teachers-carousel"},[_c('div',{staticClass:"teachers-carousel__main"},[_c('div',{staticClass:"teachers-carousel__swiper swiper-wrapper"},_vm._l((_vm.teacherCardsData),function(teacher,index){return _c('div',{key:index,staticClass:"teachers-carousel__card swiper-slide"},[_c('img',{staticClass:"teachers-carousel__teacher",attrs:{"src":teacher.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"teachers-carousel__info"},[_c('div',{staticClass:"teachers-carousel__row-1"},[_c('span',{staticClass:"teachers-carousel__name"},[_vm._v(_vm._s(teacher.name))]),_vm._v(" "),_c('span',{staticClass:"teachers-carousel__tag"},_vm._l((teacher.teacherRankLabels),function(tag){return _c('span',{key:tag,staticClass:"fs10"},[_vm._v(_vm._s(tag))])}))]),_vm._v(" "),_c('div',{staticClass:"teachers-carousel__row-2"},[_c('div',{staticClass:"teacher-info"},[_c('div',{staticClass:"teacher-info__item"},[_c('span',{staticClass:"teacher-info__text txt-cut"},[_vm._v(_vm._s(teacher.introduce))])])])]),_vm._v(" "),_c('div',{staticClass:"teachers-carousel__row-3"},_vm._l((teacher.goodAt),function(feature,fIdx){return _c('span',{key:fIdx,staticClass:"teachers-carousel__feature txt-cut"},[_vm._v(_vm._s(feature))])}))])])}))]),_vm._v(" "),_c('div',{staticClass:"teachers-swiper-pagination"})])]),_vm._v(" "),_c('div',{staticClass:"join-btn-wrap"})]),_vm._v(" "),_c('div',{staticClass:"home-page__section home-page__section--4"},[_c('h3',{staticClass:"home-page__subtitle home-page__subtitle--04"},[_vm._v("个性化定制课程")]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","height":"8.6rem","overflow":"hidden"}},[_c('div',{staticClass:"lesson-carousel"},[_c('div',{staticClass:"lesson-carousel__main"},[_c('div',{staticClass:"lesson-carousel__card-group swiper-wrapper"},_vm._l((_vm.LessonCardsData),function(lessons){return _c('div',{key:lessons.index,staticClass:"swiper-slide"},[_c('div',{staticClass:"lesson-carousel__card"},[_c('div',{staticClass:"lesson-carousel__name"},[_vm._v("\n                                    "+_vm._s(lessons.name)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"lesson-carousel__name2"},[_vm._v("\n                                    "+_vm._s(lessons.secondTitle)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"lesson-carousel__item"},[_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":".26rem","color":"#333333","display":"block"}},[_vm._v("课程策略")]),_vm._v(" "),_c('span',{staticStyle:{"display":"block","font-family":"PingFangSC-Regular","font-size":".26rem","color":"#606266"}},[_vm._v(_vm._s(lessons.des))])]),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"lesson-carousel__item2"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"lesson-carousel__txt"},[_vm._v(_vm._s(lessons.beforeClass))])]),_vm._v(" "),_c('div',{staticClass:"lesson-carousel__item2"},[_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"lesson-carousel__txt"},[_vm._v(_vm._s(lessons.inClass))])]),_vm._v(" "),_c('div',{staticClass:"lesson-carousel__item2"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"lesson-carousel__txt"},[_vm._v(_vm._s(lessons.afterClass))])])])])})),_vm._v(" "),_c('div',{staticClass:"lesson-swiper-pagination"})])])]),_vm._v(" "),_c('div',{staticClass:"join-btn-wrap"})]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"home-page__section home-page__section--footer"},[_c('div',{staticClass:"company-infos"},[_c('span',{staticClass:"company-infos__item"},[_c('span',{staticClass:"fz9"},[_c('span',{on:{"click":_vm.userAgreement}},[_vm._v("用户协议/")]),_vm._v(" "),_c('span',{on:{"click":_vm.privacyAgreement}},[_vm._v("隐私政策/")]),_vm._v(" "),_c('span',{on:{"click":_vm.childPrivaryPolicy}},[_vm._v("儿童隐私政策")])])]),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13)])]),_vm._v(" "),_c('SignupDialog',{model:{value:(_vm.signupDialogVisible),callback:function ($$v) {_vm.signupDialogVisible=$$v},expression:"signupDialogVisible"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://4020224467078.retail.n.weimob.com/saas/retail/4020224467078/6013963227078/goods/detail?id=1398651140178","target":"_blank","rel":"noopener noreferrer"}},[_c('div',{staticClass:"home-page__section home-page__section--banner"},[_c('div',{staticClass:"banner-btn-wrap"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page__section home-page__section--1 box"},[_c('h3',{staticClass:"home-page__subtitle home-page__subtitle--01"},[_vm._v("300万人的共同选择")]),_vm._v(" "),_c('div',{staticClass:"number-data"},[_c('div',{staticClass:"number-data__item"},[_c('span',{staticClass:"number-data__number"},[_vm._v("40000")]),_vm._v(" "),_c('span',{staticClass:"number-data__text"},[_vm._v("全国合作院校")])]),_vm._v(" "),_c('div',{staticClass:"number-data__item"},[_c('span',{staticClass:"number-data__number"},[_vm._v("260"),_c('span',{staticClass:"number-data__plus"},[_vm._v("亿条")])]),_vm._v(" "),_c('span',{staticClass:"number-data__text"},[_vm._v("考试数据")])]),_vm._v(" "),_c('div',{staticClass:"number-data__item",staticStyle:{"text-align":"center","width":"100%"}},[_c('span',{staticClass:"number-data__number"},[_vm._v("300"),_c('span',{staticClass:"number-data__plus"},[_vm._v("万")])]),_vm._v(" "),_c('span',{staticClass:"number-data__text"},[_vm._v("学习用户")])])]),_vm._v(" "),_c('div',{staticClass:"join-btn-wrap"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page__section home-page__section--2"},[_c('h3',{staticClass:"home-page__subtitle home-page__subtitle--02"},[_vm._v("为什么选择我们")]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","height":"3.7rem","overflow":"hidden"}},[_c('div',{staticClass:"reason-cards__main"},[_c('div',{staticClass:"reason-cards swiper-wrapper"},[_c('div',{staticClass:"swiper-slide",staticStyle:{"padding":"0 .15rem"}},[_c('div',{staticClass:"reason-cards__item"},[_c('span',{staticClass:"reason-cards__title"},[_c('span',{staticClass:"reason-cards__index"},[_vm._v("01.")]),_vm._v("全面分析本地化考情，圈定学习范围\n                            ")]),_vm._v(" "),_c('span',{staticClass:"reason-cards__text"},[_vm._v("分析当地中高考考纲考情，圈定本地考试范围及难度系数")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-slide",staticStyle:{"padding":"0 .15rem"}},[_c('div',{staticClass:"reason-cards__item"},[_c('span',{staticClass:"reason-cards__title"},[_c('span',{staticClass:"reason-cards__index"},[_vm._v("02.")]),_vm._v("定位个人当地层次水平，明确学习方向\n                            ")]),_vm._v(" "),_c('span',{staticClass:"reason-cards__text"},[_vm._v("精准分析学生历次考试，定位当前学习水平，明确方向")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-slide",staticStyle:{"padding":"0 .15rem"}},[_c('div',{staticClass:"reason-cards__item"},[_c('span',{staticClass:"reason-cards__title"},[_c('span',{staticClass:"reason-cards__index"},[_vm._v("03.")]),_vm._v("本地化教材解读，设计教学内容\n                            ")]),_vm._v(" "),_c('span',{staticClass:"reason-cards__text"},[_vm._v("针对当地教材合理设计教学内容，学生学习更有侧重点")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-slide",staticStyle:{"padding":"0 .15rem"}},[_c('div',{staticClass:"reason-cards__item"},[_c('span',{staticClass:"reason-cards__title"},[_c('span',{staticClass:"reason-cards__index"},[_vm._v("04.")]),_vm._v("本地化共性错题，课后练习更高效\n                            ")]),_vm._v(" "),_c('span',{staticClass:"reason-cards__text"},[_vm._v("分析共性错题成因和考点，选取区域精品试题，课后刷题不盲目")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-slide",staticStyle:{"padding":"0 .15rem"}},[_c('div',{staticClass:"reason-cards__item"},[_c('span',{staticClass:"reason-cards__title"},[_c('span',{staticClass:"reason-cards__index"},[_vm._v("05.")]),_vm._v("中高考数据分析，本地考向预测更到位\n                            ")]),_vm._v(" "),_c('span',{staticClass:"reason-cards__text"},[_vm._v("剖析当地考试大数据，预测中高考考向，靶向复习更有效")])])])]),_vm._v(" "),_c('div',{staticClass:"reason-swiper-pagination"})])]),_vm._v(" "),_c('div',{staticClass:"join-btn-wrap"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson-carousel__item2"},[_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":".26rem","color":"#333333","display":"block"}},[_vm._v("课程结构")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-center"},[_c('span',{staticClass:"sanjiao_down"}),_vm._v(" "),_c('span',{staticClass:"lesson-carousel__label"},[_vm._v("课前预习 ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-center"},[_c('span',{staticClass:"sanjiao_down"}),_vm._v(" "),_c('span',{staticClass:"lesson-carousel__label"},[_vm._v("课中讲/练 ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-center"},[_c('span',{staticClass:"sanjiao_down"}),_vm._v(" "),_c('span',{staticClass:"lesson-carousel__label"},[_vm._v("课后复习 ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page__section home-page__section--5"},[_c('h3',{staticClass:"home-page__subtitle home-page__subtitle--05"},[_vm._v("个性化学习更高效")]),_vm._v(" "),_c('div',{staticClass:"study-helps"},[_c('span',{staticClass:"study-helps__point study-helps__point--1"},[_c('span',{staticClass:"fz10"},[_vm._v("01")])]),_vm._v(" "),_c('span',{staticClass:"study-helps__point study-helps__point--2"},[_c('span',{staticClass:"fz10"},[_vm._v("02")])]),_vm._v(" "),_c('span',{staticClass:"study-helps__point study-helps__point--3"},[_c('span',{staticClass:"fz10"},[_vm._v("03")])]),_vm._v(" "),_c('span',{staticClass:"study-helps__point study-helps__point--4"},[_c('span',{staticClass:"fz10"},[_vm._v("04")])]),_vm._v(" "),_c('span',{staticClass:"study-helps__point study-helps__point--5"},[_c('span',{staticClass:"fz10"},[_vm._v("05")])]),_vm._v(" "),_c('div',{staticClass:"study-helps__text study-helps__text--1"},[_vm._v("大数据分析"),_c('br'),_vm._v("精准诊断")]),_vm._v(" "),_c('div',{staticClass:"study-helps__text study-helps__text--2"},[_vm._v("结合当地教学"),_c('br'),_vm._v("定制提升方案")]),_vm._v(" "),_c('div',{staticClass:"study-helps__text study-helps__text--3"},[_vm._v("智能匹配"),_c('br'),_vm._v("合适老师")]),_vm._v(" "),_c('div',{staticClass:"study-helps__text study-helps__text--4"},[_vm._v("在线约课"),_c('br'),_vm._v("想学就学")]),_vm._v(" "),_c('div',{staticClass:"study-helps__text study-helps__text--5"},[_vm._v("1对1专属"),_c('br'),_vm._v("教学更有效")])]),_vm._v(" "),_c('div',{staticClass:"join-btn-wrap"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page__section home-page__section--6"},[_c('h3',{staticClass:"home-page__subtitle home-page__subtitle--06"},[_vm._v("特色增值服务")]),_vm._v(" "),_c('div',{staticClass:"value-added-services"},[_c('div',{staticClass:"value-added-services__item"},[_c('i',{staticClass:"value-added-services__icon value-added-services__icon--1"}),_vm._v(" "),_c('span',{staticClass:"value-added-services__title"},[_vm._v("专业学业规划")]),_vm._v(" "),_c('div',{staticClass:"value-added-services__text"},[_vm._v("每人配备一个专业学习规划师为孩子的学习路径保驾护航。")])]),_vm._v(" "),_c('div',{staticClass:"value-added-services__item"},[_c('i',{staticClass:"value-added-services__icon value-added-services__icon--2"}),_vm._v(" "),_c('span',{staticClass:"value-added-services__title"},[_vm._v("知识图谱")]),_vm._v(" "),_c('div',{staticClass:"value-added-services__text"},[_vm._v("对考点题型系统拆解，在学生脑海里构建出“知识树”，让学习更简单。")])]),_vm._v(" "),_c('div',{staticClass:"value-added-services__item"},[_c('i',{staticClass:"value-added-services__icon value-added-services__icon--3"}),_vm._v(" "),_c('span',{staticClass:"value-added-services__title"},[_vm._v("三色笔记")]),_vm._v(" "),_c('div',{staticClass:"value-added-services__text"},[_vm._v("总结课堂上重要知识点，经典例题，解题方法和核心思路一眼即知。")])]),_vm._v(" "),_c('div',{staticClass:"value-added-services__item"},[_c('i',{staticClass:"value-added-services__icon value-added-services__icon--4"}),_vm._v(" "),_c('span',{staticClass:"value-added-services__title"},[_vm._v("家长课堂")]),_vm._v(" "),_c('div',{staticClass:"value-added-services__text"},[_vm._v("组建学习群，定期推出学习习惯、方法等课程，让家长帮助孩子进步。")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page__section home-page__section--7"},[_c('h3',{staticClass:"home-page__subtitle home-page__subtitle--07"},[_vm._v("服务保障")]),_vm._v(" "),_c('div',{staticClass:"service-protection"},[_c('div',{staticClass:"service-protection__pos"},[_c('div',{staticClass:"service-protection__item service-protection__item--1"},[_c('i',{staticClass:"service-protection__icon service-protection__icon--1"}),_vm._v(" "),_c('span',{staticClass:"service-protection__text"},[_vm._v("先试听"),_c('br'),_vm._v("满意再付费")])]),_vm._v(" "),_c('div',{staticClass:"service-protection__item service-protection__item--2"},[_c('i',{staticClass:"service-protection__icon service-protection__icon--2"}),_vm._v(" "),_c('span',{staticClass:"service-protection__text"},[_vm._v("老师"),_c('br'),_vm._v("任意选随时换")])]),_vm._v(" "),_c('div',{staticClass:"service-protection__item service-protection__item--3"},[_c('i',{staticClass:"service-protection__icon service-protection__icon--3"}),_vm._v(" "),_c('span',{staticClass:"service-protection__text"},[_vm._v("课程不满意"),_c('br'),_vm._v("随时退款")])]),_vm._v(" "),_c('div',{staticClass:"service-protection__item service-protection__item--4"},[_c('i',{staticClass:"service-protection__icon service-protection__icon--4"}),_vm._v(" "),_c('span',{staticClass:"service-protection__text"},[_vm._v("7x14小时"),_c('br'),_vm._v("专享贴心服务")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page__section home-page__section--8"},[_c('h3',{staticClass:"home-page__subtitle home-page__subtitle--08"},[_vm._v("企业荣誉")]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","height":"3.7rem","overflow":"hidden"}},[_c('div',{staticClass:"company-honor__main"},[_c('div',{staticClass:"honor-cards swiper-wrapper"},[_c('div',{staticClass:"swiper-slide"},[_c('div',{staticClass:"honor-cards__item"},[_c('img',{staticClass:"honor-cards__img",attrs:{"src":__webpack_require__("PoFL"),"alt":"中国教育技术协会会员单位"}}),_vm._v(" "),_c('span',{staticClass:"honor-cards__text"},[_vm._v("中国教育"),_c('br'),_vm._v("技术协会会员单位")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-slide"},[_c('div',{staticClass:"honor-cards__item"},[_c('img',{staticClass:"honor-cards__img",attrs:{"src":__webpack_require__("9aQH"),"alt":"中关村前沿科技与产业服务联盟理事单位"}}),_vm._v(" "),_c('span',{staticClass:"honor-cards__text"},[_vm._v("中关村前沿科技与"),_c('br'),_vm._v("产业服务联盟理事单位")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-slide"},[_c('div',{staticClass:"honor-cards__item"},[_c('img',{staticClass:"honor-cards__img",attrs:{"src":__webpack_require__("mE6Z"),"alt":"国家高新技术企业"}}),_vm._v(" "),_c('span',{staticClass:"honor-cards__text"},[_vm._v("国家"),_c('br'),_vm._v("高新技术企业")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-slide"},[_c('div',{staticClass:"honor-cards__item"},[_c('img',{staticClass:"honor-cards__img",attrs:{"src":__webpack_require__("50dM"),"alt":"中关村高新技术企业"}}),_vm._v(" "),_c('span',{staticClass:"honor-cards__text"},[_vm._v("中关村"),_c('br'),_vm._v("高新技术企业")])])]),_vm._v(" "),_c('div',{staticClass:"swiper-slide"},[_c('div',{staticClass:"honor-cards__item"},[_c('img',{staticClass:"honor-cards__img",attrs:{"src":__webpack_require__("Y8qX"),"alt":"中关村前沿技术企业"}}),_vm._v(" "),_c('span',{staticClass:"honor-cards__text"},[_vm._v("中关村"),_c('br'),_vm._v("前沿技术企业")])])])]),_vm._v(" "),_c('div',{staticClass:"reason-swiper-pagination"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"company-infos__item"},[_c('span',{staticClass:"fz9"},[_vm._v("北京市海淀区东升科技园学院八号 北京修齐治平科技有限公司")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"company-infos__item"},[_c('a',{attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/"}},[_c('span',{staticClass:"fz9"},[_vm._v("京ICP备16000182号-5")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"company-infos__item"},[_c('a',{attrs:{"target":"_blank","href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042360"}},[_c('span',{staticClass:"fz9"},[_c('img',{staticClass:"footer-gaba",attrs:{"src":__webpack_require__("1tYL")}}),_vm._v("京公网安备11010502042360号")])])])}]


/***/ }),

/***/ "vvAD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ErrorCode: {
        Success: 0,
        Empty: 1,
        CookieInvalid: 1101
    },
    Subject: {
        1: '语文',
        2: '数学',
        3: '英语',
        4: '物理',
        5: '化学',
        6: '生物',
        7: '政治',
        8: '历史',
        9: '地理',
        10: '奥数'
    },
    WeekDay: {
        0: '星期日',
        1: '星期一',
        2: '星期二',
        3: '星期三',
        4: '星期四',
        5: '星期五',
        6: '星期六'
    },
    Grade: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二文',
        33: '高二理',
        34: '高三文',
        35: '高三理',
        11: '小学一年级',
        12: '小学二年级',
        13: '小学三年级',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下',
        1: '小学',
        2: '初中',
        3: '高中'
    },
    Grade2: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二文',
        33: '高二理',
        34: '高三文',
        35: '高三理',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下'
    },
    Grade3: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        36: '高二',
        37: '高三',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下'
    },
    TransactionStatus: {
        1: '处理中',
        2: '支付成功',
        3: '支付失败',
        4: '交易关闭',
        5: '取消充值'
    },
    GoodsType: {
        1: '学费',
        2: '学豆'
    },
    PayThrough: {
        1: '学费余额',
        11: '支付宝',
        12: '支付宝',
        13: '支付宝',
        14: '花呗分期',
        97: '支付宝',
        21: '微信',
        22: '微信',
        23: '微信',
        24: '微信',
        25: '微信',
        26: '微信',
        27: '微信',
        31: '财付通',
        41: '慧学空间',
        51: '课时置换',
        52: '课时变更',
        61: '民生银行',
        71: '度小满金融',
        95: '银联',
        96: '银联',
        98: '旧平台',
        99: '未知'
    },
    LessonType: {
        // 试听
        FREE_LESSON: 1,
        // 课时计划
        FORMAL_LESSON: 2,
        // 答疑课
        QA_LESSON: 3
    },
    // 标准课时包等级
    StandardClassPackageLevel: {
        1: '基础',
        2: '高级',
        3: 'VIP'
    },
    // 课时记录类型
    PeriodRecordType: {
        1: '一般课时包',
        2: '标准课时包',
        3: '标准课时包升级',
        4: '订单'
    }
};

/***/ }),

/***/ "xQFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignupDialog_vue__ = __webpack_require__("/Gvf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377ee938_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupDialog_vue__ = __webpack_require__("g5hg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("lz0s")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-377ee938"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignupDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377ee938_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupDialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377ee938_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupDialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["vUwe"]);


// WEBPACK FOOTER //
// static/js/mobile.796aa233e8053ac905b6.js